// BuilderHelpPopup - 画面ごとのヘルプ
// 各画面（AI / ブロック一覧 / 履歴 / 左パネル / ピース情報）のヘルプボタンから開く。
// 文章だけでは読まれないので、手引き（BuilderGuideBook）と同じく
// その画面のキャプチャを見せ、説明する場所を丸で囲む／拡大する。

import { GuideBookId, BuilderGuideBook, GuideBookChapter } from "features/builder/elements";

export const BuilderHelpPopup = ({
  open,
  onClose,
  chapters,
}: {
  open: boolean;
  onClose: () => void;
  chapters: GuideBookChapter[];
}) => (
  <BuilderGuideBook open={open} book={GuideBookId.EDITOR} chapters={chapters} onClose={onClose} />
);
